import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group"

import { styled } from "@/stitches"

import { IconButton } from "./button"

// -----------------------------------------------------------------------------
// Primitives
// -----------------------------------------------------------------------------

const StyledRoot = styled(ToggleGroupPrimitive.Root, {
  display: "inline-flex",
})

const StyledItem = styled(ToggleGroupPrimitive.Item, IconButton, {
  mx: "-$1",

  "@sm": {
    mx: 0,
  },

  "&[data-state=on]": {
    color: "$accent9",
  },

  "&[data-state=off]": {
    color: "$gray11",
  },
})

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

export const Root = StyledRoot
export const Item = StyledItem
